import React from "react";

import styled from "styled-components";

import Button from "ds/Button";

const SelectedButton = styled(Button)`
  color: var(--skye);
  background-color: var(--ebony);
`;

const UnselectedButton = styled(Button)``;

type TableTreeButtonProps = {
  selected?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
};

export const TableTreeDefaultButton = styled(Button)`
  background-color: var(--ebony);
`;

export const TableTreeButton = ({
  selected,
  onClick,
  children
}: TableTreeButtonProps) => {
  const ButtonComponent = selected ? SelectedButton : UnselectedButton;

  return (
    <ButtonComponent
      analyticId="process.buttons"
      onClick={onClick}
      content="icon"
      iconSize="large"
      variant="dark"
      disabled={selected ? true : undefined}
    >
      {children}
    </ButtonComponent>
  );
};
